import { Component } from '@angular/core';
import { Headers, Http, RequestOptions } from '@angular/http';

import { DialogService } from 'ng2-bootstrap-modal';
import { environment } from '../../environments/environment';
import { APIURLS, USERSESSIONVIEWLABELS } from '../_constants/constants';
import { AgentProfileService } from '../_services/agent.profile.service';
import { LogoutDialogComponent } from '../logout/logout.dialog.component';

@Component({
  selector: 'app-user-session',
  templateUrl: './user-session.component.html',
  styleUrls: ['./user-session.component.css'],
})

export class UserSessionComponent {
  usersessionviewlabels = USERSESSIONVIEWLABELS;
  agentProfileService: AgentProfileService;
  accountURL: string = USERSESSIONVIEWLABELS.MY_ACCOUNT_LINK_PRE;

  constructor(private ds: DialogService, agentProfileService: AgentProfileService) {
    this.agentProfileService = agentProfileService;    

    console.log("Hostname: ", window.location.hostname)

    if (window.location.hostname === 'cct2.vodafone.com' || window.location.hostname === 'localhost' || window.location.hostname === 'preprod.idcc.vodafone.com' || window.location.hostname === 'qa.idcc.vodafone.com'|| window.location.hostname === 'staging.cct.id.aws.cps.vodafone.com') {
      this.accountURL = USERSESSIONVIEWLABELS.MY_ACCOUNT_LINK_PRE;
    }
    if (window.location.hostname === 'idcc.vodafone.com') {
      this.accountURL = USERSESSIONVIEWLABELS.MY_ACCOUNT_LINK_PROD;
    }   
  }

  openLogoutDialog() {
    this.ds.addDialog(LogoutDialogComponent);
  }
}



// WEBPACK FOOTER //
// ./src/app/user-session/user-session.component.ts